// @flow
import React from "react";
import {connect} from "react-redux";
import {
    BottomProposalContainer,
    BottomProposalIcon,
    ProposalAcceptButton, ProposalAcceptButtonLabel,
    ProposalETA,
    ProposalETARow,
} from "./ProposalBottomStyle";
import { strings, styles, images } from '../../../../config';
import ProgressBar from "../../../ProgressBar/ProgressBar";
import CurrentProposalSelectors from "../../../../Store/Ducks/CurrentProposal/selectors";

const getPickupEtaString = (etaInMinutes: number) => {
    const minuteValue = Math.max(0, Math.floor(parseFloat(etaInMinutes)));
    if (minuteValue === 0) {
        return strings.proposal_eta_less_than_minute;
    } else if (minuteValue === 1) {
        return strings.proposal_eta_one_minute;
    }
    return strings.proposal_eta_more_than_minute.supplant({minuteValue: minuteValue.toString()});

};

type OwnProps = {
    proposalProgress: number;
    eta: number;
    onProposalAccept: () => mixed;
}

const ProposalBottom = (props: OwnProps) => {
    return (
        <BottomProposalContainer>
            <ProposalETARow>
                <BottomProposalIcon src={images.proposal_regular_icon} alt="proposal_icon"/>
                <ProposalETA>
                    {getPickupEtaString(props.eta)}
                </ProposalETA>
            </ProposalETARow>
            <ProposalAcceptButton onClick={props.onProposalAccept}>
                <ProposalAcceptButtonLabel>
                    {strings.book_ride_label_text}
                </ProposalAcceptButtonLabel>
            </ProposalAcceptButton>
            <ProgressBar progress={props.proposalProgress} maxProgress={100} fill={styles.secondaryColor}/>
        </BottomProposalContainer>
    );
};

const mapStateToProps = state => {
    return {
        eta: CurrentProposalSelectors.proposalETA(state),
    };
};

export default connect(mapStateToProps)(ProposalBottom);



// WEBPACK FOOTER //
// ./src/Components/Screen/Proposal/ProposalBottom/ProposalBottom.js